var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cake-layout"},[_c('CacheRouterView')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }